import { PickupLocation } from "@redotech/redo-model/return-enums";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const rescheduleReturnPickup = {
  name: "rescheduleReturnPickup" as const,
  input: z.object({
    returnId: zExt.objectId(),
    pickupDate: z.string(),
    pickupLocation: createEnum(PickupLocation),
    specialInstructions: z.string().optional(),
    pickupReadyTime: z
      .object({ hours: z.number(), minutes: z.number() })
      .optional(),
  }),
  output: z.object({}),
};
